import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import CrudList from "@/components/CrudList";

export default function BBM() {
  const [assets, setAssets] = useState([]);
  const [sites, setSites] = useState([]);
  useEffect(() => {
    api.get("/assets").then((r) => setAssets(r.data));
    api.get("/sites").then((r) => setSites(r.data));
  }, []);
  return (
    <CrudList
      title="BBM (Bahan Bakar)"
      subtitle="Log pengisian BBM per alat, per site"
      endpoint="/bbm"
      exportModule="bbm"
      auditEntity="bbm_logs"
      columns={[
        { key: "date", label: "Tanggal" },
        { key: "asset_id", label: "Aset", render: (r) => assets.find((a) => a.id === r.asset_id)?.code || "-" },
        { key: "liter", label: "Liter" },
        { key: "price_per_liter", label: "Harga/L", render: (r) => "Rp " + (r.price_per_liter || 0).toLocaleString('id-ID') },
        { key: "total", label: "Total", render: (r) => "Rp " + ((r.liter || 0) * (r.price_per_liter || 0)).toLocaleString('id-ID') },
        { key: "site_id", label: "Site", render: (r) => sites.find((s) => s.id === r.site_id)?.name || "-" },
      ]}
      fields={[
        { key: "date", label: "Tanggal", type: "date", required: true },
        { key: "asset_id", label: "Aset", type: "select", options: assets.map((a) => ({ value: a.id, label: `${a.code} - ${a.name}` })), required: true },
        { key: "liter", label: "Liter", type: "number", required: true },
        { key: "price_per_liter", label: "Harga per Liter (Rp)", type: "number", required: true },
        { key: "site_id", label: "Site", type: "select", options: sites.map((s) => ({ value: s.id, label: s.name })) },
        { key: "note", label: "Catatan", wide: true },
        { key: "photo_url", label: "Foto Nota BBM", type: "photo", kind: "bbm", wide: true },
      ]}
    />
  );
}
